/* unplugin-vue-components disabled */import { render } from "./hints-input.vue?vue&type=template&id=01fd42a3&scoped=true"
import script from "./hints-input.vue?vue&type=script&lang=js"
export * from "./hints-input.vue?vue&type=script&lang=js"

import "./hints-input.vue?vue&type=style&index=0&id=01fd42a3&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fd42a3"],['__file',"src/components/hints-input/hints-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01fd42a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01fd42a3', __exports__)) {
    api.reload('01fd42a3', __exports__)
  }
  
  module.hot.accept("./hints-input.vue?vue&type=template&id=01fd42a3&scoped=true", () => {
    api.rerender('01fd42a3', render)
  })

}


export default __exports__